import { Guid } from "guid-typescript";
import FileTypes from "../../types/enums/FileTypes";
import QueuedExportSubTypes from "../../types/enums/QueuedExportSubType";

export default class QueuedExportFile {
    id: Guid;
    fileId: number;
    schoolID: number;
    type: FileTypes;
    subType: QueuedExportSubTypes;
    date: Date;
    createdOn: Date;
    completedOn: Date;
    azureURL: string;

    constructor(data: Partial<QueuedExportFile>) {
        Object.assign(this, data);

        if (typeof this.date === "string")
            this.date = new Date(this.date);

        if (typeof this.createdOn === "string")
            this.createdOn = new Date(this.createdOn);

        if (typeof this.completedOn === "string")
            this.completedOn = new Date(this.completedOn);
    }
}